var _defs, _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElementosMovilV1HeaderColor22Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 192",
    width: 1080,
    height: 192,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "elementos_movil-v1_header-color-21-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96.28 63.56h59.89v59.11h-59.89z"
  })), /*#__PURE__*/React.createElement("image", {
    width: 234,
    height: 210,
    id: "img1",
    href: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmlld0JveD0iMCAwIDExNyAxMDUiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEsIC5jbHMtMiB7CiAgICAgICAgZmlsbDogI2U4ZTVlMjsKICAgICAgfQoKICAgICAgLmNscy0yIHsKICAgICAgICBmaWx0ZXI6IHVybCgjZHJvcC1zaGFkb3ctMSk7CiAgICAgIH0KCiAgICAgIC5jbHMtMyB7CiAgICAgICAgZmlsbDogIzUwYjdiMDsKICAgICAgfQogICAgPC9zdHlsZT4KICAgIDxmaWx0ZXIgaWQ9ImRyb3Atc2hhZG93LTEiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxmZU9mZnNldCBkeD0iNDAuMDkiIGR5PSIyMC4wNSIvPgogICAgICA8ZmVHYXVzc2lhbkJsdXIgcmVzdWx0PSJibHVyIiBzdGREZXZpYXRpb249IjIwLjA1Ii8+CiAgICAgIDxmZUZsb29kIGZsb29kLWNvbG9yPSIjNDA0MDU0IiBmbG9vZC1vcGFjaXR5PSIuMTUiLz4KICAgICAgPGZlQ29tcG9zaXRlIGluMj0iYmx1ciIgb3BlcmF0b3I9ImluIi8+CiAgICAgIDxmZUNvbXBvc2l0ZSBpbj0iU291cmNlR3JhcGhpYyIvPgogICAgPC9maWx0ZXI+CiAgPC9kZWZzPgogIDxyZWN0IGNsYXNzPSJjbHMtMiIgeD0iLTExMjgiIHk9Ii0zMS42OSIgd2lkdGg9IjEwODAiIGhlaWdodD0iMTkyIi8+CiAgPGc+CiAgICA8cmVjdCBjbGFzcz0iY2xzLTMiIHg9Ii0uMDciIHk9Ii43NSIgd2lkdGg9IjExNyIgaGVpZ2h0PSIxMDQuNSIgcng9IjI1Ljg2IiByeT0iMjUuODYiLz4KICAgIDxnPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjI5LjIxIiB5PSIyMy42NyIgd2lkdGg9IjU4LjQ0IiBoZWlnaHQ9IjExLjIzIiByeD0iMS40MyIgcnk9IjEuNDMiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy0xIiB4PSIyOS4yMSIgeT0iNDcuNDQiIHdpZHRoPSI1OC40NCIgaGVpZ2h0PSIxMS4yMyIgcng9IjEuNDMiIHJ5PSIxLjQzIi8+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iMjkuMjEiIHk9IjcxLjIxIiB3aWR0aD0iNTguNDQiIGhlaWdodD0iMTEuMjMiIHJ4PSIxLjQzIiByeT0iMS40MyIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #50b7b0 } \n\t\t.s1 { fill: #ffffff } \n\t\t.s2 { mix-blend-mode: multiply;fill: #47baec } \n\t\t.s3 { fill: #e8e5e2 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m0.2-25.5h1079.8v243h-1079.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m128.2 125.9q-3.3-1-7.7-3-3.9-1.7-6.5-2.6-2.6-0.8-5.2-0.8-4.6 0-8.3 1.6-3.7 1.7-7.6 5.3v-54q3.2-3.4 7.1-4.9 3.8-1.6 9-1.6 3.6 0 6.9 1.1 3.2 1 7.7 3 3.8 1.7 6.4 2.5 2.6 0.9 5.3 0.9 4.6 0 8.3-1.7 3.7-1.6 7.6-5.3v54.1q-3.3 3.4-7.1 4.9-3.9 1.5-9.1 1.5-3.6 0-6.8-1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m132.6 90.8q-3.4-1.1-8-3.1-3.9-1.8-6.6-2.6-2.7-0.9-5.4-0.9-4.7 0-8.5 1.7-3.9 1.6-7.8 5.4v-21.1q3.3-3.5 7.2-5.1 4-1.6 9.4-1.6 3.7 0.1 7 1.1 3.3 1.1 7.9 3.1 4 1.7 6.6 2.6 2.7 0.9 5.4 0.9 4.8 0 8.6-1.7 3.8-1.6 7.8-5.4v21.1q-3.4 3.5-7.3 5.1-3.9 1.5-9.3 1.5-3.7 0-7-1zm-0.1 30.8q-3.3-1.1-7.9-3.1-3.9-1.7-6.6-2.6-2.7-0.9-5.4-0.9-4.7 0-8.5 1.7-3.9 1.6-7.8 5.5v-21.2q3.4-3.5 7.3-5 3.9-1.6 9.3-1.6 3.7 0 7 1.1 3.3 1 7.9 3.1 4 1.7 6.6 2.6 2.7 0.8 5.4 0.8 4.8 0.1 8.6-1.6 3.8-1.7 7.8-5.5v21.1q-3.3 3.5-7.3 5.1-4 1.6-9.3 1.6-3.7 0-7.1-1.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m240 72.1q0-4.2 1.7-7.1 1.6-2.9 4.9-4.4 3.3-1.6 8-1.5 2.9 0 5.4 0.5v6q-2.4-0.5-4.8-0.5-2.6 0-4.2 0.8-1.7 0.7-2.5 2.2-0.8 1.5-0.8 3.9c0 1.7 0.3 3 0.8 4q0.8 1.5 2.4 2.2 1.6 0.7 4.2 0.7 2.2 0 4.9-0.7v6.1q-1.2 0.3-2.7 0.5-1.5 0.2-3 0.2-14.3 0-14.3-12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m275.4 66.4q2.1 0.8 3.1 2.7 1 1.9 1 5.1v10.5h-6l-0.5-1.8h-0.3q-1.5 2.1-4.7 2.1-2 0-3.4-0.7-1.5-0.7-2.2-2-0.8-1.2-0.8-2.9 0-2.8 2.1-4.4 2-1.5 6.4-1.8l2.2-0.1q-0.1-0.8-0.5-1.2-0.4-0.5-1.2-0.7-0.8-0.2-2.1-0.2-1.2 0-2.6 0.2-1.4 0.2-2.6 0.5v-5.4q1.5-0.3 3.2-0.5 1.8-0.2 3.3-0.2 3.5 0 5.6 0.8zm-3 13.3v-2.7h-1.5q-2.1 0.2-2.1 1.7 0 0.7 0.4 1 0.5 0.4 1.3 0.4 1.1 0 1.9-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m309.8 67.5q1.7 1.9 1.7 6v11.2h-7.2v-10.8q0-1.2-0.5-1.6-0.4-0.5-1.2-0.5-1.1 0-1.9 0.6 0 0.2 0 0.8v11.5h-7.1v-10.8q0-1.2-0.4-1.6-0.4-0.5-1.2-0.5-0.6 0-1.1 0.2-0.6 0.3-0.9 0.7v12h-7.3v-18.8h6l0.4 1.8h0.4q1.9-2.1 5.1-2.1 1.6 0 2.8 0.5 1.2 0.6 2 1.8 1.1-1.2 2.6-1.8 1.4-0.5 2.9-0.5 3.1 0 4.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m314.8 65.9h-0.1zm6.1 0l0.5 1.9h0.3q0.8-1 2-1.6 1.2-0.6 2.8-0.6 2.2 0 4 1 1.8 1 2.9 3.1 1 2.1 1 5.2c0 2.1-0.4 4-1.2 5.5q-1.2 2.3-3.6 3.4-2.4 1.2-5.9 1.2-0.6 0-1.6 0v7.2h-7.3v-26.3zm5.4 12.7q0.9-0.9 0.9-3.1 0-2.3-0.8-3.2-0.7-0.9-2.1-0.9-0.6 0-1.2 0.2-0.5 0.1-1 0.4v7.5q0.9 0.1 1.6 0.1 1.8 0 2.6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m349.7 66.4q2.1 0.8 3.1 2.7 1 1.9 1 5.1v10.5h-6l-0.5-1.8h-0.3q-1.5 2.1-4.7 2.1-1.9 0-3.4-0.7-1.4-0.7-2.2-2-0.7-1.2-0.7-2.9 0-2.8 2-4.4 2-1.5 6.4-1.8l2.2-0.1q-0.1-0.8-0.5-1.2-0.4-0.5-1.2-0.7-0.8-0.2-2.1-0.2-1.2 0-2.5 0.2-1.4 0.2-2.6 0.5v-5.4q1.5-0.3 3.2-0.5 1.7-0.2 3.3-0.2 3.4 0 5.5 0.8zm-3 13.3v-2.7h-1.5q-2.1 0.2-2.1 1.7 0 0.7 0.5 1 0.4 0.4 1.2 0.4 1.2 0 1.9-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m357 65.9h6l0.5 1.8h0.3q0.9-1 2.3-1.6 1.3-0.5 2.9-0.5 3.1 0 4.9 1.9 1.8 1.9 1.8 5.9v11.3h-7.3v-10.8q0-1.2-0.4-1.6-0.5-0.5-1.4-0.5-0.7 0-1.3 0.2-0.6 0.3-1 0.6v12h-7.3v-18.7zm10.7-2.7q-0.7-0.3-1.7-0.7-0.9-0.4-1.5-0.6-0.5-0.2-1.2-0.2-1 0-1.8 0.4-0.9 0.3-1.7 1.2v-4.4q0.7-0.8 1.6-1.1 0.9-0.3 2.1-0.3 0.8 0 1.5 0.2 0.7 0.2 1.7 0.7 0.9 0.4 1.5 0.6 0.5 0.1 1.2 0.1 1 0.1 1.8-0.3 0.9-0.4 1.7-1.2v4.4q-0.7 0.7-1.6 1-0.9 0.4-2.1 0.4-0.8 0-1.5-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m391.7 66.4q2.1 0.8 3.1 2.7 1 1.9 1 5.1v10.5h-6l-0.5-1.8h-0.3q-1.5 2.1-4.7 2.1-2 0-3.4-0.7-1.5-0.7-2.2-2-0.8-1.2-0.8-2.9 0-2.8 2.1-4.4 2-1.5 6.4-1.8l2.2-0.1q-0.1-0.8-0.5-1.2-0.4-0.5-1.2-0.7-0.8-0.2-2.1-0.2-1.2 0-2.6 0.2-1.3 0.2-2.5 0.5v-5.4q1.4-0.3 3.2-0.5 1.7-0.2 3.2-0.2 3.5 0 5.6 0.8zm-3 13.3v-2.7h-1.5q-2.1 0.2-2.1 1.7 0 0.7 0.4 1 0.5 0.4 1.3 0.4 1.1 0 1.9-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m424.4 59.4h7v25.3h-7.4l-9.1-14.2v14.2h-7v-25.3h7.4l9.1 14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m447.8 66.4q2 0.8 3 2.7 1 1.9 1 5.1v10.5h-6l-0.5-1.8h-0.3q-1.4 2.1-4.7 2.1-1.9 0-3.4-0.7-1.4-0.7-2.2-2-0.7-1.2-0.7-2.9 0-2.8 2-4.4 2-1.5 6.4-1.8l2.3-0.1q-0.2-0.8-0.5-1.2-0.5-0.5-1.2-0.7-0.9-0.2-2.2-0.2-1.1 0-2.5 0.2-1.4 0.2-2.6 0.5v-5.4q1.5-0.3 3.2-0.5 1.7-0.2 3.3-0.2 3.4 0 5.5 0.8zm-3 13.3v-2.7h-1.5q-2.1 0.2-2.1 1.7 0 0.7 0.5 1 0.4 0.4 1.3 0.4 1.1 0 1.8-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m457 82.6q-2.7-2.5-2.7-7.3c0-3.2 0.9-5.6 2.8-7.3q2.9-2.4 8.3-2.4 2.5 0 4.5 0.4v5.6q-1.9-0.2-3.4-0.2-2.5 0-3.6 0.9-1.2 1-1.2 3c0 1.3 0.4 2.4 1.1 3q1.1 0.9 3.3 1 0.8 0 1.7-0.2 0.8-0.1 2-0.4v5.7q-1 0.3-2.3 0.5-1.2 0.1-2.6 0.1-5.2 0-7.9-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m472.1 60.5q0-3.6 4.4-3.6 4.3 0 4.3 3.6 0 3.5-4.3 3.5-4.4 0-4.4-3.5zm0.8 24.2v-18.8h7.3v18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m487.3 83.9q-2.2-1.1-3.4-3.3-1.2-2.1-1.2-5.3 0-4.7 2.6-7.2 2.5-2.5 7.3-2.5 3.2 0 5.4 1.1 2.2 1.1 3.4 3.3 1.1 2.2 1.1 5.3 0 3.1-1.2 5.3-1.2 2.2-3.4 3.3-2.2 1.1-5.3 1.1-3.1 0-5.3-1.1zm6.8-4.7q0.5-0.4 0.8-1.3 0.3-0.9 0.3-2.6c0-1-0.1-1.9-0.3-2.6q-0.3-0.9-0.8-1.3-0.6-0.4-1.5-0.4-0.9 0-1.5 0.4-0.5 0.4-0.8 1.3-0.3 0.9-0.3 2.6 0 1.7 0.3 2.6 0.3 0.9 0.8 1.3 0.6 0.4 1.5 0.4 0.9 0 1.5-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m505.1 65.9h6l0.4 1.8h0.4q0.9-1 2.3-1.6 1.3-0.5 2.9-0.5 3.1 0 4.9 1.9 1.8 1.9 1.8 5.9v11.3h-7.3v-10.8q0-1.2-0.5-1.6-0.4-0.5-1.3-0.5-0.7 0-1.3 0.2-0.6 0.3-1 0.6v12h-7.3v-18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m539.8 66.4q2.1 0.8 3.1 2.7 1 1.9 1 5.1v10.5h-6l-0.5-1.8h-0.3q-1.5 2.1-4.7 2.1-2 0-3.4-0.7-1.5-0.7-2.2-2-0.8-1.2-0.8-2.9 0-2.8 2.1-4.4 2-1.5 6.4-1.8l2.2-0.1q-0.1-0.8-0.5-1.2-0.4-0.5-1.2-0.7-0.8-0.2-2.1-0.2-1.2 0-2.6 0.2-1.3 0.2-2.5 0.5v-5.4q1.4-0.3 3.2-0.5 1.7-0.2 3.2-0.2 3.5 0 5.6 0.8zm-3 13.3v-2.7h-1.5q-2.1 0.2-2.1 1.7 0 0.7 0.4 1 0.5 0.4 1.3 0.4 1.1 0 1.9-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m547.1 84.7v-27.6h7.2v27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m569.6 84q-1.8-1-2.9-3.1-1.1-2.1-1.1-5.2c0-2.1 0.4-4 1.3-5.5q1.2-2.3 3.6-3.5 2.4-1.1 5.9-1.2 0.6 0 1.6 0.1v-8.5h7.2v27.6h-6.1l-0.4-2h-0.3q-0.8 1.1-2 1.7-1.3 0.6-2.9 0.6-2.2 0-3.9-1zm7.4-5q0.5-0.2 1-0.4v-7.5q-0.9-0.1-1.6-0.1-1.8 0-2.6 0.9-0.9 1-0.9 3.2 0 2.2 0.8 3.1 0.7 0.9 2.1 0.9 0.6 0 1.2-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m606 77.3h-10.9q0.1 0.9 0.5 1.4 0.5 0.5 1.6 0.7 1 0.2 2.9 0.2 2.1 0 4.8-0.5v5.4q-2.9 0.5-5.9 0.5-3.9 0-6.4-1-2.5-1-3.6-3.2-1.2-2.1-1.2-5.6 0-3 1.1-5.1 1.1-2.2 3.2-3.4 2.1-1.1 5.2-1.1 4.3 0 6.5 2.6 2.2 2.6 2.2 7.3c0 0 0 1.8 0 1.8zm-10-7q-0.5 0.3-0.7 1-0.3 0.7-0.3 2h4.3q0-1.3-0.2-2-0.3-0.7-0.7-1-0.5-0.3-1.2-0.3-0.8 0-1.2 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m617.4 59.9q4.2-0.9 8.4-0.9 6.1 0.1 9.1 2.3 3 2.3 3 7.2c0 3.3-0.9 5.5-2.9 7.1q-2.9 2.4-8.4 2.4h-0.9q-0.3 0-0.9 0v6.7h-7.4zm12.4 11.7q0.9-0.9 0.9-3.1c0-1.4-0.3-2.4-1-3.1q-1-0.9-3.2-0.9-1 0-1.7 0.1v7.8q0.9 0.1 1.9 0.1 2.1 0 3.1-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m640.6 65.9h5.9l0.6 2.3h0.3q1.3-2.6 4.6-2.6 0.8 0 1.6 0.1v6.5q-0.8-0.1-2-0.1-1.1 0-2.1 0.3-1.1 0.3-1.6 0.9v11.4h-7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m672.9 77.3h-11q0.2 0.9 0.6 1.4 0.5 0.5 1.6 0.7 1 0.2 2.9 0.2 2.1 0 4.8-0.5v5.4q-2.9 0.5-5.9 0.5-3.9 0-6.4-1-2.5-1-3.7-3.2-1.1-2.1-1.1-5.6 0-3 1.1-5.1 1-2.2 3.2-3.4 2.1-1.1 5.1-1.1 4.3 0 6.6 2.6 2.2 2.6 2.2 7.3c0 0 0 1.8 0 1.8zm-10-7q-0.5 0.3-0.7 1-0.3 0.7-0.3 2h4.3q0-1.3-0.3-2-0.2-0.7-0.6-1-0.5-0.3-1.2-0.3-0.8 0-1.2 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m687.5 65.9h7.1l-6.3 18.8h-9l-6.3-18.8h7.6l3.4 12.1c0 0 3.4-12.1 3.5-12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m713.1 77.3h-11q0.1 0.9 0.6 1.4 0.5 0.5 1.5 0.7 1.1 0.2 3 0.2 2.1 0 4.8-0.5v5.4q-3 0.5-5.9 0.5-4 0-6.4-1-2.5-1-3.7-3.2-1.2-2.1-1.2-5.6 0-3 1.1-5.1 1.1-2.2 3.2-3.4 2.2-1.1 5.2-1.1 4.3 0 6.5 2.6 2.3 2.6 2.3 7.3c0 0 0 1.8 0 1.8zm-10.1-7q-0.4 0.3-0.7 1-0.2 0.7-0.2 2h4.3q-0.1-1.3-0.3-2-0.2-0.7-0.7-1-0.4-0.3-1.2-0.3-0.7 0-1.2 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m715.5 65.9h5.9l0.5 1.8h0.3q1-1 2.3-1.6 1.4-0.5 3-0.5 3 0 4.8 1.9 1.8 1.9 1.8 5.9v11.3h-7.2v-10.8q0-1.2-0.5-1.6-0.4-0.5-1.4-0.5-0.6 0-1.2 0.2-0.6 0.3-1.1 0.6v12h-7.2v-18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m739.3 82.6q-2.7-2.5-2.7-7.3c0-3.2 0.9-5.6 2.9-7.3q2.9-2.4 8.2-2.4 2.5 0 4.5 0.4v5.6q-1.9-0.2-3.4-0.2-2.5 0-3.6 0.9-1.1 1-1.1 3c0 1.3 0.3 2.4 1 3q1.1 0.9 3.3 1 0.9 0 1.7-0.2 0.9-0.1 2.1-0.4v5.7q-1.1 0.3-2.3 0.5-1.3 0.1-2.6 0.1-5.3 0-8-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m754.5 60.5q0-3.6 4.3-3.6 4.4 0 4.4 3.6 0 3.5-4.4 3.5-4.3 0-4.3-3.5zm0.7 24.2v-18.8h7.3v18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m769.6 83.9q-2.2-1.1-3.4-3.3-1.2-2.1-1.2-5.3 0-4.7 2.6-7.2 2.6-2.5 7.3-2.5 3.2 0 5.4 1.1 2.2 1.1 3.4 3.3 1.1 2.2 1.1 5.3 0 3.1-1.2 5.3-1.2 2.2-3.4 3.3-2.2 1.1-5.3 1.1-3.1 0-5.3-1.1zm2-20.1l4-6.7h7.7l-5.1 6.7c0 0-6.6 0-6.6 0zm4.8 15.4q0.6-0.4 0.9-1.3 0.2-0.9 0.2-2.6c0-1-0.1-1.9-0.3-2.6q-0.3-0.9-0.8-1.3-0.6-0.4-1.5-0.4-0.9 0-1.4 0.4-0.6 0.4-0.9 1.3-0.3 0.9-0.3 2.6 0 1.7 0.3 2.6 0.3 0.9 0.8 1.3 0.6 0.4 1.5 0.4 0.9 0 1.5-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m787.4 65.9h6l0.5 1.8h0.3q0.9-1 2.3-1.6 1.3-0.5 2.9-0.5 3.1 0 4.9 1.9 1.8 1.9 1.8 5.9v11.3h-7.3v-10.8q0-1.2-0.4-1.6-0.5-0.5-1.4-0.5-0.7 0-1.3 0.2-0.6 0.3-1 0.6v12h-7.3v-18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m243.6 134.2q-1.8-1-2.8-3.1-1.1-2.1-1.1-5.2c0-2.1 0.4-4 1.2-5.5q1.2-2.2 3.6-3.4 2.4-1.2 5.9-1.2 0.7 0 1.6 0.1v-8.6h7.3v27.6h-6.1l-0.4-1.9h-0.3q-0.9 1-2.1 1.6-1.2 0.6-2.8 0.6-2.2 0-4-1zm7.4-5q0.6-0.1 1-0.4v-7.4q-0.9-0.2-1.5-0.2-1.8 0-2.7 1-0.8 0.9-0.8 3.1 0 2.3 0.7 3.2 0.7 0.9 2.1 0.9 0.6 0 1.2-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m280.1 127.5h-11q0.1 0.9 0.6 1.4 0.5 0.5 1.5 0.7 1.1 0.3 3 0.3 2.1 0 4.8-0.5v5.3q-3 0.6-5.9 0.6-4 0-6.4-1.1-2.5-1-3.7-3.2-1.2-2.1-1.2-5.5 0-3 1.1-5.2 1.1-2.2 3.2-3.3 2.2-1.2 5.2-1.2 4.3 0 6.5 2.6 2.3 2.6 2.3 7.3c0 0 0 1.8 0 1.8zm-10.1-7q-0.4 0.4-0.7 1.1-0.2 0.7-0.2 1.9h4.3q-0.1-1.2-0.3-1.9-0.2-0.8-0.7-1.1-0.4-0.3-1.2-0.3-0.7 0-1.2 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m291.2 134.9v-27.6h7.3v27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m314.6 116.6q2.1 0.8 3.1 2.7 1 1.9 1 5.2v10.4h-6l-0.5-1.7h-0.3q-1.5 2.1-4.7 2.1-2 0-3.4-0.8-1.4-0.7-2.2-2-0.7-1.2-0.7-2.9 0-2.8 2-4.4 2-1.5 6.4-1.8l2.2-0.1q-0.1-0.7-0.5-1.2-0.4-0.5-1.2-0.7-0.8-0.2-2.1-0.2-1.2 0-2.5 0.2-1.4 0.2-2.6 0.5v-5.3q1.4-0.4 3.2-0.6 1.7-0.2 3.3-0.2 3.4 0 5.5 0.8zm-3 13.3v-2.7l-1.5 0.1q-2.1 0.1-2.1 1.6 0 0.7 0.4 1.1 0.5 0.3 1.3 0.3 1.2 0 1.9-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m321.6 134.4v-5.2q1.4 0.4 3 0.6 1.7 0.3 3.4 0.3 1.4 0 2-0.3 0.5-0.2 0.5-0.7 0-0.3-0.2-0.5-0.2-0.1-0.7-0.2l-3.4-0.6q-2.7-0.5-3.9-1.8-1.3-1.4-1.3-3.8 0-2 1.1-3.4 1-1.5 3.2-2.2 2.2-0.8 5.5-0.8 1.4 0 2.9 0.1 1.4 0.2 2.5 0.5v5.2q-1.1-0.3-2.5-0.5-1.3-0.1-2.7-0.1-1.9 0-2.6 0.3-0.7 0.2-0.7 0.7 0 0.3 0.2 0.4 0.2 0.2 0.7 0.3l3.4 0.5q2.6 0.5 3.9 1.8 1.3 1.3 1.4 3.8 0 2-1.1 3.5-1.1 1.4-3.2 2.2-2 0.7-4.9 0.7-3.6 0-6.5-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m365.3 109.6h7.2l-7.5 25.3h-11l-7.5-25.3h7.7l5.5 19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m373.3 110.7q0-3.6 4.4-3.6 4.3 0 4.3 3.6 0 3.6-4.3 3.6-4.4 0-4.4-3.6zm0.7 24.2v-18.8h7.3v18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m388.5 134.2q-2.2-1.2-3.4-3.3-1.2-2.2-1.2-5.3 0-4.8 2.5-7.3 2.6-2.5 7.4-2.5 3.1 0 5.4 1.1 2.2 1.1 3.3 3.3 1.2 2.2 1.2 5.3 0 3.2-1.2 5.3-1.2 2.2-3.4 3.3-2.2 1.2-5.3 1.2-3.1 0-5.3-1.1zm6.7-4.7q0.6-0.4 0.9-1.4 0.3-0.9 0.3-2.5c0-1.1-0.1-2-0.3-2.7q-0.3-0.9-0.9-1.3-0.5-0.4-1.4-0.4-0.9 0-1.5 0.4-0.6 0.4-0.9 1.3-0.2 1-0.2 2.6 0 1.7 0.2 2.6 0.3 1 0.9 1.4 0.6 0.3 1.5 0.3 0.9 0 1.4-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m406.2 134.9v-27.6h7.3v27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m423.3 127.5q0.1 0.9 0.6 1.4 0.5 0.5 1.5 0.7 1.1 0.3 3 0.3 2.1 0 4.8-0.5v5.3q-2.9 0.6-5.9 0.6-3.9 0-6.4-1.1-2.5-1-3.7-3.2-1.1-2.1-1.1-5.5 0-3 1-5.2 1.1-2.2 3.3-3.3 2.1-1.2 5.1-1.2 4.3 0 6.6 2.6 2.2 2.6 2.2 7.3v1.8zm0.9-7q-0.5 0.4-0.7 1.1-0.2 0.7-0.3 1.9h4.3q0-1.2-0.2-1.9-0.2-0.8-0.7-1.1-0.4-0.3-1.2-0.3-0.7 0-1.2 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m436.7 116.1h6l0.5 1.8h0.3q0.9-1 2.3-1.6 1.3-0.5 2.9-0.5 3.1 0 4.9 1.9 1.8 1.9 1.8 5.9v11.3h-7.3v-10.8q0-1.1-0.5-1.6-0.4-0.5-1.3-0.5-0.7 0-1.3 0.2-0.6 0.3-1 0.7v12h-7.3v-18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m460.6 132.8q-2.8-2.5-2.8-7.3c0-3.2 1-5.6 2.9-7.3q2.9-2.4 8.3-2.4 2.4 0 4.4 0.4v5.6q-1.9-0.2-3.4-0.2-2.5 0-3.6 0.9-1.1 1-1.1 3c0 1.3 0.3 2.4 1.1 3q1 1 3.3 1 0.8 0 1.6-0.2 0.9-0.1 2.1-0.4v5.7q-1 0.3-2.3 0.5-1.3 0.2-2.6 0.2-5.2 0-8-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m475.7 110.7q0-3.6 4.3-3.6 4.4 0 4.4 3.6 0 3.6-4.4 3.6-4.3 0-4.3-3.6zm0.7 24.2v-18.8h7.3v18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m499.9 116.6q2 0.8 3 2.7 1 1.9 1 5.2v10.4h-6l-0.5-1.7h-0.3q-1.4 2.1-4.7 2.1-1.9 0-3.4-0.8-1.4-0.7-2.2-2-0.7-1.2-0.7-2.9 0-2.8 2-4.4 2-1.5 6.4-1.8l2.3-0.1q-0.2-0.7-0.5-1.2-0.5-0.5-1.2-0.7-0.9-0.2-2.2-0.2-1.1 0-2.5 0.2-1.4 0.2-2.6 0.5v-5.3q1.5-0.4 3.2-0.6 1.7-0.2 3.3-0.2 3.4 0 5.5 0.8zm-3 13.3v-2.7l-1.5 0.1q-2.1 0.1-2.1 1.6 0 0.7 0.5 1.1 0.4 0.3 1.3 0.3 1.1 0 1.8-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m506.8 134.4v-5.2q1.4 0.4 3 0.6 1.7 0.3 3.4 0.3 1.4 0 2-0.3 0.5-0.2 0.5-0.7 0-0.3-0.2-0.5-0.2-0.1-0.7-0.2l-3.4-0.6q-2.6-0.5-3.9-1.8-1.3-1.4-1.3-3.8 0-2 1.1-3.4 1.1-1.5 3.2-2.2 2.2-0.8 5.5-0.8 1.4 0 2.9 0.1 1.4 0.2 2.5 0.5v5.2q-1.1-0.3-2.5-0.5-1.3-0.1-2.7-0.1-1.9 0-2.6 0.3-0.7 0.2-0.7 0.7 0 0.3 0.2 0.4 0.2 0.2 0.8 0.3l3.3 0.5q2.6 0.5 4 1.8 1.3 1.3 1.3 3.8 0 2-1.1 3.5-1.1 1.4-3.2 2.2-2 0.7-4.8 0.7-3.7 0-6.6-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m536.6 134.2q-1.8-1-2.8-3.1-1.1-2.1-1.1-5.2c0-2.1 0.4-4 1.2-5.5q1.2-2.2 3.6-3.4 2.4-1.2 5.9-1.2 0.7 0 1.6 0.1v-8.6h7.3v27.6h-6.1l-0.4-1.9h-0.3q-0.8 1-2.1 1.6-1.2 0.6-2.8 0.6-2.2 0-4-1zm7.4-5q0.6-0.1 1-0.4v-7.4q-0.9-0.2-1.6-0.2-1.7 0-2.6 1-0.8 0.9-0.8 3.1 0 2.3 0.7 3.2 0.7 0.9 2.1 0.9 0.6 0 1.2-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m562.1 127.5q0.1 0.9 0.6 1.4 0.5 0.5 1.5 0.7 1.1 0.3 3 0.3 2.1 0 4.8-0.5v5.3q-3 0.6-5.9 0.6-4 0-6.4-1.1-2.5-1-3.7-3.2-1.1-2.1-1.1-5.5 0-3 1-5.2 1.1-2.2 3.2-3.3 2.2-1.2 5.2-1.2 4.3 0 6.5 2.6 2.3 2.6 2.3 7.3v1.8zm0.9-7q-0.5 0.4-0.7 1.1-0.3 0.7-0.3 1.9h4.3q0-1.2-0.2-1.9-0.3-0.8-0.7-1.1-0.5-0.3-1.2-0.3-0.8 0-1.2 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m605.9 122.6v12q-3.7 0.6-6.7 0.6-7.8 0-11.6-3.2-3.8-3.2-3.8-9.7c0-4.3 1.3-7.5 3.9-9.7q4-3.3 11.7-3.3 3.1 0 5.7 0.5v6.1q-2.6-0.5-5-0.6-3.1 0.1-5 0.8-1.9 0.7-2.7 2.3-0.9 1.5-0.9 4 0 3.5 1.7 5.1 1.8 1.7 5.4 1.7h0.5v-6.6h6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m626.9 127.5h-10.9q0.1 0.9 0.6 1.4 0.4 0.5 1.5 0.7 1 0.3 3 0.3 2 0 4.7-0.5v5.3q-2.9 0.6-5.8 0.6-4 0-6.5-1.1-2.4-1-3.6-3.2-1.2-2.1-1.2-5.5 0-3 1.1-5.2 1.1-2.2 3.2-3.3 2.1-1.2 5.2-1.2 4.3 0 6.5 2.6 2.2 2.6 2.2 7.3c0 0 0 1.8 0 1.8zm-12.2-13.4l4-6.8h7.7l-5.1 6.8c0 0-6.6 0-6.6 0zm2.2 6.4q-0.5 0.4-0.7 1.1-0.2 0.7-0.3 1.9h4.3q0-1.2-0.2-1.9-0.2-0.8-0.7-1.1-0.5-0.3-1.2-0.3-0.7 0-1.2 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m629.3 116.1h6l0.5 1.8h0.3q1-1 2.3-1.6 1.4-0.5 3-0.5 3 0 4.8 1.9 1.8 1.9 1.8 5.9v11.3h-7.3v-10.8q0-1.1-0.4-1.6-0.5-0.5-1.4-0.5-0.7 0-1.3 0.2-0.6 0.3-1 0.7v12h-7.3v-18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m668.7 127.5h-11q0.1 0.9 0.6 1.4 0.5 0.5 1.5 0.7 1.1 0.3 3 0.3 2.1 0 4.8-0.5v5.3q-3 0.6-5.9 0.6-4 0-6.4-1.1-2.5-1-3.7-3.2-1.2-2.1-1.2-5.5 0-3 1.1-5.2 1.1-2.2 3.2-3.3 2.2-1.2 5.2-1.2 4.3 0 6.5 2.6 2.3 2.6 2.3 7.3c0 0 0 1.8 0 1.8zm-10.1-7q-0.4 0.4-0.7 1.1-0.2 0.7-0.2 1.9h4.3q-0.1-1.2-0.3-1.9-0.2-0.8-0.7-1.1-0.4-0.3-1.2-0.3-0.7 0-1.2 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m671.1 116.1h5.9l0.5 2.4h0.3q1.3-2.7 4.7-2.7 0.7 0 1.5 0.1v6.6q-0.8-0.2-2-0.2-1.1 0-2.1 0.3-1 0.4-1.6 0.9v11.4h-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m689.7 134.2q-2.2-1.2-3.4-3.3-1.2-2.2-1.2-5.3 0-4.8 2.6-7.3 2.6-2.5 7.3-2.5 3.2 0 5.4 1.1 2.2 1.1 3.4 3.3 1.1 2.2 1.1 5.3 0 3.2-1.2 5.3-1.2 2.2-3.4 3.3-2.2 1.2-5.3 1.2-3.1 0-5.3-1.1zm6.8-4.7q0.6-0.4 0.9-1.4 0.2-0.9 0.2-2.5c0-1.1-0.1-2-0.3-2.7q-0.3-0.9-0.8-1.3-0.6-0.4-1.5-0.4-0.9 0-1.4 0.4-0.6 0.4-0.9 1.3-0.3 1-0.3 2.6 0 1.7 0.3 2.6 0.3 1 0.8 1.4 0.6 0.3 1.5 0.3 0.9 0 1.5-0.3z"
  })), /*#__PURE__*/React.createElement("use", {
    id: "elementos_movil-v1_header-04",
    href: "#img1",
    transform: "matrix(.406,0,0,.406,893,53)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementosMovilV1HeaderColor22Svg);
export default __webpack_public_path__ + "static/media/elementos_movil-v1_header-color-22-svg.3265ddb88db9505a5e728a368b92785e.svg";
export { ForwardRef as ReactComponent };